// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aFh_","left":"styles_left__1hGWn","desktopActions":"styles_desktopActions__3NFku","title":"styles_title__1OMfH"};